function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { dailyStatisticsApi, putStatisticsApi } from '@/api/config';
export default {
  name: 'CrmebOaEntDaily',
  components: {
    formBox: function formBox() {
      return import('./components/formBox');
    },
    oaDialog: function oaDialog() {
      return import('@/components/form-common/dialog-form');
    },
    recordDrawer: function recordDrawer() {
      return import('./components/recordDrawer');
    },
    exportExcel: function exportExcel() {
      return import('@/components/common/exportExcel');
    }
  },
  data: function data() {
    return {
      saveName: '上下班打卡_日报_统计日期范围.xlsx',
      loading: false,
      exportData: {
        data: [],
        cols: [{
          wpx: 70
        }, {
          wpx: 70
        }, {
          wpx: 120
        }, {
          wpx: 140
        }, {
          wpx: 200
        }, {
          wpx: 120
        }, {
          wpx: 120
        }]
      },
      total: 0,
      where: {
        page: 1,
        limit: 15,
        time: '',
        scope: '',
        status: '',
        frame_id: '',
        user_id: [],
        group_id: ''
      },
      rowId: '',
      form: {
        name: '上班1',
        dis_status: '',
        dis_locationStatus: '',
        status: '',
        number: '',
        remark: '',
        location_status: ''
      },
      placeList: [{
        id: 1,
        name: '外勤卡'
      }, {
        id: 2,
        name: '地点异常'
      }],
      salesmanList: [{
        id: 1,
        name: '正常'
      }, {
        id: 2,
        name: '迟到'
      }, {
        id: 3,
        name: '严重迟到'
      }, {
        id: 4,
        name: '早退'
      }, {
        id: 5,
        name: '缺卡'
      }, {
        id: 7,
        name: '缺卡'
      }],
      val: '',
      fromData: {
        with: '600px',
        title: '打卡结果更改',
        btnText: '确定',
        labelWidth: '90px',
        type: 'slot'
      },
      tableData: []
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    openRecord: function openRecord(data) {
      this.$refs.recordDrawer.openBox(data);
    },
    openFn: function openFn(status, location_status, type, id) {
      this.rowId = id;
      this.form.remark = '';
      if (type == 1) {
        this.form.name = '上班1：';
        this.form.number = 0;
      } else if (type == 2) {
        this.form.name = '下班1：';
        this.form.number = 1;
      } else if (type == 3) {
        this.form.name = '上班2：';
        this.form.number = 2;
      } else {
        this.form.name = '下班2：';
        this.form.number = 3;
      }
      this.form.dis_status = status;
      this.form.dis_locationStatus = location_status;
      this.$refs.oaDialog.openBox();
    },
    submit: function submit() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              data = {
                number: _this.form.number,
                remark: _this.form.remark,
                status: _this.form.status,
                location_status: _this.form.location_status || 0
              };
              _context.next = 3;
              return putStatisticsApi(_this.rowId, data);
            case 3:
              _context.next = 5;
              return _this.$refs.oaDialog.handleClose();
            case 5:
              _this.getList();
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getList: function getList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.loading = true;
              _context2.next = 3;
              return dailyStatisticsApi(_this2.where);
            case 3:
              result = _context2.sent;
              _this2.loading = false;
              _this2.total = result.data.count;
              _this2.tableData = result.data.list;
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    confirmData: function confirmData(data, type) {
      this.where.page = 1;
      this.where.time = data.time;
      this.where.scope = data.scope;
      this.where.status = data.status;
      this.where.frame_id = data.frame_id;
      this.where.user_id = data.user_id;
      this.where.group_id = data.group_id;
      if (type == '导出') {
        this.exportFn();
      } else {
        this.getList();
      }
    },
    // 处理数据
    handle: function handle(status, day, time) {
      var str = '';
      if (status > 0) {
        str = day == 0 ? '当日' : '次日';
        if (time) {
          str = str + time;
        }
      } else {
        str = '--';
      }
      return str;
    },
    // 处理表格班次数据
    getShift: function getShift(data) {
      var text2 = '';
      var text1 = '';
      if (data.rules && data.rules.length !== 0) {
        text1 = "".concat(data.rules[0].first_day_after == 0 ? '当日' : '次日').concat(data.rules[0].work_hours, " - ").concat(data.rules[0].second_day_after == 0 ? '当日' : '次日').concat(data.rules[0].off_hours);
        if (data.rules[1]) {
          text2 = "".concat(data.rules[1].first_day_after == 0 ? '当日' : '次日').concat(data.rules[1].work_hours, " - ").concat(data.rules[1].second_day_after == 0 ? '当日' : '次日').concat(data.rules[1].off_hours);
        }
      }
      return text1 + text2;
    },
    exportFn: function exportFn() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var aoaData, result;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              aoaData = [['概况统计与打卡明细'], ["\u7EDF\u8BA1\u65F6\u95F4\uFF1A".concat(_this3.where.time, " \u5236\u8868\u65F6\u95F4\uFF1A").concat(_this3.$moment(new Date()).format('YYYY/MM/DD'))], ['姓名', '部门', '班次信息', '', '', '上班1', '', '下班1', '', '上班2', '', '下班2', '', '时长统计', '', '', ''], ['', '', '考勤组名称', '日期', '考勤班次', '最早打卡', '打卡结果', '最晚打卡', '打卡结果', '最早打卡', '打卡结果', '最晚打卡', '打卡结果', '应出勤', '实际出勤', '加班时长', '请假时长']];
              _this3.where.page = 0;
              _this3.where.limit = 0;
              _context3.next = 5;
              return dailyStatisticsApi(_this3.where);
            case 5:
              result = _context3.sent;
              result.data.list.map(function (item) {
                aoaData.push([item.card.name, item.frame.name, item.group || '--', _this3.$moment(item.created_at).format('YYYY-MM-DD'), item.shift_data.name + _this3.getShift(item.shift_data), _this3.handle(item.one_shift_status, item.one_shift_is_after, item.one_shift_time), _this3.getStatus(item.one_shift_status, item.one_shift_location_status, item.one_shift_normal), _this3.handle(item.two_shift_status, item.two_shift_is_after, item.two_shift_time), _this3.getStatus(item.two_shift_status, item.two_shift_location_status, item.two_shift_normal), _this3.handle(item.three_shift_status, item.three_shift_is_after, item.three_shift_time), _this3.getStatus(item.three_shift_status, item.three_shift_location_status, item.three_shift_normal), _this3.handle(item.four_shift_status, item.four_shift_is_after, item.four_shift_time), _this3.getStatus(item.four_shift_status, item.four_shift_location_status, item.four_shift_normal), item.required_work_hours + '小时', item.actual_work_hours + '小时', item.overtime_work_hours + '小时', item.leave_time + '小时']);
              });
              _this3.exportData.data = aoaData;
              _this3.$refs.exportExcel.exportExcel();
              _this3.where.page = 1;
              _this3.where.limit = 10;
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 处理表格打卡结果数据
    getStatus: function getStatus(status, tip, time) {
      var str = '';
      var tips = '';
      if (status == 1) {
        str = '正常';
      } else if (status == 0) {
        str = '--';
      } else if (status == 2) {
        str = '迟到';
      } else if (status == 3) {
        str = '严重迟到';
      } else if (status == 4) {
        str = '早退';
      } else {
        str = '缺卡';
      }
      if (tip == 0) {} else if (tip == 1) {
        tips = '(外勤卡)';
      } else if (tip == 2) {
        tips = '(地点异常)';
      }
      if (time !== 0) {
        str = str + tips + '-' + time + '分钟';
      } else {
        str = str + tips;
      }
      return str;
    },
    pageChange: function pageChange(page) {
      this.where.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.where.limit = val;
      this.getList();
    }
  }
};